import { InputText } from 'primereact/inputtext'
import { classNames } from 'primereact/utils'
import { useEffect, useMemo, useState } from 'react'
import { UseQueryResult } from 'react-query'
import { useSelector } from 'react-redux'
import { selectRefinerLineResult } from '../../../../features/projectManagement/projectManagementSlice'
import { selectRefinerState } from '../../../../features/projectManagementPmr/projectManagementPmrSlice'
import { FlexProjectItem } from '../../project-details/ProjectDetails'

type Props = {
  flexProjectQuery: UseQueryResult<Omit<FlexProjectItem, 'isActive'>[], unknown>
  selectedProjectId: string | undefined
  setSelectedProjectId: (projectId: string) => void
}

const LeftPanel = (props: Props) => {
  const { data: flexProjects, isFetching } = props.flexProjectQuery
  const [searchPhrase, setSearchPhrase] = useState<string>('')

  const refinerLineResult = useSelector(selectRefinerLineResult)
  const refinerState = useSelector(selectRefinerState)
  const filteredFlexProjects = useMemo(() => {
    const { orderLines } = refinerState.value
    return flexProjects?.filter(
      project =>
        (refinerLineResult.flexProjectIds === null ||
          !orderLines ||
          refinerLineResult.flexProjectIds?.includes(project.id)) &&
        project.name.toLowerCase().includes(searchPhrase.trim().toLowerCase())
    )
  }, [flexProjects, refinerLineResult.flexProjectIds, refinerState.value.orderLines, searchPhrase])

  useEffect(() => {
    if (filteredFlexProjects && filteredFlexProjects.length > 0) {
      props.setSelectedProjectId(filteredFlexProjects[0].id)
    }
  }, [filteredFlexProjects])

  const isProjectSelected = ({ id }: Pick<FlexProjectItem, 'id'>) => id === props.selectedProjectId

  return (
    <div className="w-[350px] mt-2 overflow-y-auto">
      {isFetching && (
        <div className="flex align-center justify-center items-center min-h-[350px]">
          <i className="pi pi-spin pi-spinner text-lg text-sky-800 mr-2" />
          Loading projects...
        </div>
      )}

      {!isFetching && (
        <>
          <div className="mx-5">
            <div className="p-input-icon-right w-full my-3">
              <i className="pi pi-search" />
              <InputText
                placeholder="Search"
                className="w-full"
                value={searchPhrase}
                onChange={e => setSearchPhrase(e.target.value)}
              />
            </div>

            <div>
              <label className="text-[.75rem] font-bold text-gray-600">
                Total of {filteredFlexProjects?.length} FLEX Project(s)
              </label>
            </div>
          </div>

          <div className="mt-3">
            {filteredFlexProjects?.map((item, index) => {
              return (
                <div
                  key={`${item.name}-${index}`}
                  onClick={() => props.setSelectedProjectId(item.id)}
                  className={classNames(
                    'cursor-pointer py-3 px-5 border border-l-0 border-gray-300',
                    isProjectSelected(item) &&
                      'bg-blue-50 border-r-sky-800 border-r-[5px] text-sky-800'
                  )}
                  title={item.name}
                >
                  <div className="text-md font-semibold">{item.name}</div>
                  <div className="text-xs font-normal">{item.status}</div>
                </div>
              )
            })}
          </div>
        </>
      )}
    </div>
  )
}

export default LeftPanel
